
export function RoleBasedMainRoutes(role: string) {
    switch (role) {
        case "ADMIN": {
            return "/alert"
        }
        case "DEVELOPER": {
            return "/alert"
        }
        case "MIS": {
          return "/mis"
      }
        default: {
            return "/"
        }
    }
}